import { defineMessages } from "react-intl";

const SHARED = "shared";

const sharedMessages = defineMessages({
  somethingWentWrong: {
    id: `${SHARED}.something-went-wrong`,
    defaultMessage: "Something went wrong."
  },
  emailAddress: {
    id: `${SHARED}.email-address`,
    defaultMessage: "Email address"
  },
  emailAddressOptional: {
    id: `${SHARED}.email-address-optional`,
    defaultMessage: "Email address (optional)"
  },
  emailUseDescription: {
    id: `${SHARED}.email-use-description`,
    defaultMessage:
      "Your email address can be used to set up alerts and place holds on EBSCO eBooks."
  },
  firstName: {
    id: `${SHARED}.first-name`,
    defaultMessage: "First name"
  },
  firstNameOptional: {
    id: `${SHARED}.first-name-optional`,
    defaultMessage: "First name (optional)"
  },
  lastNameOptional: {
    id: `${SHARED}.last-name-optional`,
    defaultMessage: "Last name (optional)"
  },
  username: {
    id: `${SHARED}.username`,
    defaultMessage: "Username"
  },
  password: {
    id: `${SHARED}.password`,
    defaultMessage: "Password"
  },
  requireFirstName: {
    id: `${SHARED}.require-first-name`,
    defaultMessage: "Please provide a first name."
  },
  requireUsername: {
    id: `${SHARED}.require-username`,
    defaultMessage: "Please provide a username."
  },
  requireEmailAddress: {
    id: `${SHARED}.require-email-address`,
    defaultMessage: "Please provide an email address."
  },
  invalidEmailAddress: {
    id: `${SHARED}.invalid-email-address`,
    defaultMessage: "Please provide a valid email address."
  },
  personalDataRetentionAndUsage: {
    id: `${SHARED}.personal-data-retention-and-usage`,
    defaultMessage: "Personal data retention and usage"
  },
  dataRetentionAndUsage: {
    id: `${SHARED}.data-retention-and-usage`,
    defaultMessage: "Data Retention and Usage"
  },
  myAccountEbsco: {
    id: `${SHARED}.my-account-ebsco`,
    defaultMessage: "My Account - EBSCO"
  },
  productsAndServices: {
    id: `${SHARED}.products-and-services`,
    defaultMessage: "Products and Services"
  },
  preexistingEmailAddress: {
    id: `${SHARED}.preexisting-email-address`,
    defaultMessage: "This email address already exists in our system."
  },
  preexistingUsername: {
    id: `${SHARED}.preexisting-username`,
    defaultMessage: "This username already exists in our system."
  },
  backToMyAccount: {
    id: `${SHARED}.back-to-my-account`,
    defaultMessage: "Back to my account",
    description:
      "Link that directs the user back to the account update page from a secondary page"
  },
  unableToCreateAccount: {
    id: `${SHARED}.unable-to-create`,
    defaultMessage: "Unable to create account. Please try again later."
  },
  close: {
    id: `${SHARED}.close`,
    defaultMessage: "Close"
  },
  loading: {
    id: `${SHARED}.loading`,
    defaultMessage: "Loading..."
  },
  back: {
    id: `${SHARED}.back`,
    defaultMessage: "Back"
  },
  exceededAllowedRequestAttempts: {
    id: `${SHARED}.exceeded-allowed-request-attempts`,
    defaultMessage:
      "You have exceeded your allowed request attempts. Please try again later."
  },
  signIn: {
    id: `${SHARED}.sign-in`,
    defaultMessage: "Sign in"
  },
  save: {
    id: `${SHARED}.save`,
    defaultMessage: "Save"
  },
  resetPassword: {
    id: `${SHARED}.reset-password`,
    defaultMessage: "Reset password",
    description: "Title for page (and text for button) to reset a user password"
  },
  confirmPassword: {
    id: `${SHARED}.confirm-password`,
    defaultMessage: "Confirm new password",
    description: "Label for confirm password text input"
  },
  requireNewPassword: {
    id: `${SHARED}.require-new-password`,
    defaultMessage: "Please provide your new password.",
    description: "Input error displayed if new password is not entered"
  },
  requireConfirmPassword: {
    id: `${SHARED}.require-confirm-password`,
    defaultMessage: "Please confirm your new password.",
    description:
      "Input error displayed if confirmation of new password is not entered"
  },
  passwordsDoNotMatch: {
    id: `${SHARED}.passwords-do-not-match`,
    defaultMessage: "Passwords do not match.",
    description:
      "Input error displayed if confirmation of new password does not match new password"
  },
  newPassword: {
    id: `${SHARED}.new-password`,
    description: "Label for new password input field",
    defaultMessage: "New password"
  },
  mergeAccounts: {
    id: `${SHARED}.merge-accounts`,
    defaultMessage: "Merge accounts"
  },
  cancel: {
    id: `${SHARED}.cancel`,
    defaultMessage: "Cancel"
  },
  continue: {
    id: `${SHARED}.continue`,
    defaultMessage: "Continue"
  },
  createPassword: {
    id: `${SHARED}.create-password`,
    defaultMessage: "Create password"
  },
  hide: { id: `${SHARED}.hide`, defaultMessage: "Hide" },
  show: { id: `${SHARED}.show`, defaultMessage: "Show" },
  currentlySignedInAs: {
    id: `${SHARED}.currently-signed-in-as`,
    defaultMessage:
      "Currently signed in as <styledUsername>{username}</styledUsername>"
  }
});

export default sharedMessages;
